export default __webpack_public_path__ + "static/media/FurJadenHikingCamping1.d7c31c9b.jpg";